import React from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import Badge from '@mui/material/Badge'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import AddIcon from '@mui/icons-material/Add'
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined'
import SearchIcon from '@mui/icons-material/Search'
import { PATIENT_BOTTOM_MOBILE_HEIGHT } from '@/v2/constants'
import { useNotification } from '@/v2/hooks/messages/useNotification'

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${PATIENT_BOTTOM_MOBILE_HEIGHT};
  width: 100%;
  padding: 12px 24px;
  padding-left: calc(24px + env(safe-area-inset-left));
  padding-right: calc(24px + env(safe-area-inset-right));
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-top: 1px solid #eee;
  z-index: 100;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  color: ${({ theme }) => theme?.gray?.dark || '#666'};

  &:active {
    opacity: 0.7;
  }
`

const PatientBarMobile = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { notification = {} } = useNotification()
  const { chat, tasks } = notification
  const { messagesUnreadCount = 0, conversationsUnreadCount = 0 } = chat || {}
  const { uncompletedCount = 0 } = tasks || {}

  const hasUnreadMessages =
    messagesUnreadCount > 0 || conversationsUnreadCount > 0

  return (
    <Wrapper theme={theme.palette}>
      <IconWrapper
        theme={theme.palette}
        onClick={() => navigate('/v2/calendar')}
      >
        <CalendarTodayOutlinedIcon />
      </IconWrapper>

      <IconWrapper
        theme={theme.palette}
        onClick={() => navigate('/v2/messages')}
      >
        {hasUnreadMessages ? (
          <Badge
            badgeContent={messagesUnreadCount || ''}
            color="error"
            variant={messagesUnreadCount === 0 ? 'dot' : 'standard'}
          >
            <ChatBubbleOutlineIcon />
          </Badge>
        ) : (
          <ChatBubbleOutlineIcon />
        )}
      </IconWrapper>

      <IconWrapper
        theme={theme.palette}
        onClick={() => navigate('/v2/event/new')}
      >
        <AddIcon sx={{ fontSize: 28 }} />
      </IconWrapper>

      <IconWrapper theme={theme.palette} onClick={() => navigate('/v2/tasks')}>
        {uncompletedCount > 0 ? (
          <Badge badgeContent={uncompletedCount} color="error">
            <AssignmentTurnedInOutlinedIcon />
          </Badge>
        ) : (
          <AssignmentTurnedInOutlinedIcon />
        )}
      </IconWrapper>

      <IconWrapper theme={theme.palette} onClick={() => navigate('/v2/search')}>
        <SearchIcon />
      </IconWrapper>
    </Wrapper>
  )
}

export default PatientBarMobile
